import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QuestionMarkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"question_mark"}/>
}
